module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_04.d8553ee9.jpg";